import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const CatalogAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.catalogAccess
        ? setValues((j) => ({
            ...j,
            catalog: {
              create: true,
              edit: true,
              delete: true,
              status: true,
              import: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            catalog: {
              create: false,
              edit: false,
              delete: false,
              status: false,
              import: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.catalogAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      catalog: { ...j.catalog, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.catalogAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.catalog?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.catalog?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.catalog?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Status"
          checked={values.catalog?.status || false}
          name={"status"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Import"
          checked={values.catalog?.import || false}
          name={"import"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default CatalogAccess;
